import { APICore } from './apiCore'

const api = new APICore()

function getContacts (params) {
  const baseUrl = '/contacts'
  return api.get(baseUrl, params)
}

function getContact (id) {
  const baseUrl = `/contacts/${id}`
  return api.get(baseUrl, {})
}

function addContact (params) {
  const baseUrl = '/contacts'
  return api.createWithFile(baseUrl, params)
}

function updateContact (params) {
  const baseUrl = '/contacts'
  return api.updateWithFile(baseUrl, params)
}

function deleteContact (params) {
  const baseUrl = '/contacts'
  return api.delete(baseUrl, params)
}

export { getContacts, getContact, addContact, updateContact, deleteContact }
